module.exports = __webpack_public_path__ + "static/media/employee-appreciation-1.ac70deaf.jpeg";